import { createAction, props } from '@ngrx/store';
import { EducationRecordModel } from '@shared/data-access/models';

export const getList = createAction(
  '[Education record] GET LIST',
  props<{payload:EducationRecordModel[]}>()
);
